module.exports = __webpack_public_path__ + "img/logo-vclinic_1.906d12fb.png";